/** 允许最多上传的图片数量 */
export const MAX_IMAGE_COUNT = 6;
